import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import LegalTableCMSItemModel from '@/visa-application/models/LegalTableCMSItemModel';

export default class LegalTermsWebsiteContentSlotCMSModel implements CMSModel {
  title = '';
  sort = '';
  short_desc = '';
  table_title = '';
  table_content: LegalTableCMSItemModel = new LegalTableCMSItemModel();
  long_desc = '';
  tag = [];
  slot_title_translation = '';

  map(obj: any): LegalTermsWebsiteContentSlotCMSModel {
    this.title = _.get(obj, 'title', 'Undefined');
    this.sort = _.get(obj, 'sort', 'Undefined');
    this.short_desc = _.get(obj, 'translation[0].short_desc', 'Undefined');
    this.table_title = _.get(obj, 'translation[0].table_title', 'Undefined');
    this.table_content = _.get(obj, 'translation[0].table_content', 'Undefined');
    this.long_desc = _.get(obj, 'translation[0].long_desc', 'Undefined');
    this.slot_title_translation = _.get(obj, 'translation[0].slot_title_translation', 'Undefined');
    this.tag = _.get(obj, 'tag', []);
    return this;
  }
}
